<template>
    <div>
      <card>
        <div v-if="showSearchForm">
          <Form :model="params" inline label-colon @submit.native.prevent @keyup.enter.native="search">
            <slot name="searchForm" />
            <FormItem>
              <Button type="primary" :loading="loading" @click="search" >查询</Button>
            </FormItem>
          </Form>
        </div>
        <div>
          <slot name="tableHeaderBtn" />
          <Button v-if="showCreateBtn" :loading="loading" type="info" plain icon="md-add-circle" style="margin-bottom: 10px;" @click="crudHandle('new', {})">{{ createBtnTitle }}</Button>
        </div>
        <Table :ref="refName" stripe width="100%" :max-height="maxHeight" :size="lsize" :border="border" :columns="tableColumns" :data="tableData" :loading="loading" :highlight-row="highlightRow" @on-sort-change="sortChange" @on-row-click="rowClick">
          <template v-if="showActionsColumn" slot-scope="{ row, index }" slot="action">
              <Tooltip v-for="(action, i) in actions" :key="i" v-permission="action.permission" :content="action.name" placement="top" transfer>
                <Button :type="action.type" :icon="action.icon" :size="action.size" style="margin-right: 5px" @click="crudHandle(action.handle, row)" />
              </Tooltip>
          </template>
          <template v-for="(c) in tableColumns" :slot="c.slot" slot-scope="scope">
            <slot v-if="c.slot" :name="c.slot" :row="scope.row" />
          </template>
        </Table>
        <Page v-if="pageTotal > 0" :disabled="loading" :total="pageTotal" :current.sync="page.page_no" :page-size-opts="pageSizes" :page-size.sync="page.page_size" @on-change="fetchData" @on-page-size-change="pageSizeChange" show-total show-sizer style="margin-top: 10px" />
      </card>
    </div>
</template>

<script>
export default {
  name: 'index',
  props: {
    refName: {
      type: String,
      default: 'pageTable'
    },
    lsize: {
      type: String,
      default: 'middle'
    },
    highlightRow: {
      type: Boolean,
      default: false
    },
    maxHeight: {
      type: Number,
      default: 0
    },
    tableData: {
      type: Array
    },
    columns: {
      type: Array,
      default: () => {}
    },
    border: {
      type: Boolean,
      default: false
    },
    params: {
      type: Object,
      default: () => {}
    },
    loading: {
      type: Boolean,
      default: false
    },
    showSearchForm: {
      type: Boolean,
      default: true
    },
    showCreateBtn: {
      type: Boolean,
      default: true
    },
    createBtnTitle: {
      type: String,
      default: '新增'
    },
    showActionsColumn: {
      type: Boolean,
      default: false
    },
    actions: {
      type: Array,
      default: () => {}
    },
    pageTotal: {
      type: Number,
      default: 0
    },
    pageSizes: {
      type: Array,
      default: () => [15, 30, 50, 150]
    },
    initFetch: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      page: {
        page_no: 1,
        page_size: 15
      },
      filterParams: {}
    }
  },
  mounted () {
    if (this.initFetch) {
      this.fetchData()
    }
  },
  computed: {
    tableColumns () {
      const columns = this.columns
      if (this.showActionsColumn) {
        columns.push({ title: '操作', slot: 'action', align: 'center', fixed: 'left', minWidth: 150, maxWidth: 250 })
      }
      return columns
    }
  },
  methods: {
    crudHandle (type, row) {
      this.$emit('btnHandler', type, row)
    },
    getBtnType (type) {
      return this.typeMap[type].type
    },
    getBtnTitle (type) {
      return this.typeMap[type].title
    },
    getBtnIcon (type) {
      return this.typeMap[type].icon
    },
    search () {
      this.filterParams = {}
      this.page.page_no = 1
      this.fetchData()
    },
    refresh () {
      this.fetchData()
    },
    pageSizeChange (e) {
      this.page.page_size = e
      this.page.page_no = 1
      this.fetchData()
    },
    fetchData () {
      this.$emit('fetchData', { ...this.filterParams, ...this.page })
    },
    rowClick (params) {
      this.$emit('rowClick', params)
    },
    sortChange ({ column, prop, order }) {
      if (order) {
        this.filterParams.sortColumn = prop
        this.filterParams.sortType = order
      } else {
        delete this.filterParams.sortColumn
        delete this.filterParams.sortType
      }
      this.columnChange()
    },
    columnChange () {
      this.page.page_no = 1
      this.fetchData()
    }
  }
}
</script>

<style scoped>

</style>
